export default __webpack_public_path__ + "static/media/shape-2.9b7f6223.svg";